var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default',[_c('div',{staticClass:"wrapper"},[_c('bread-crumb'),_c('div',{staticClass:"l-main-wrapper mobileFullWidth clearfix"},[_vm._t("default")],2),_c('side-bar')],1),_c('div',{staticClass:"clear"})])}
var staticRenderFns = []

export { render, staticRenderFns }